import React from 'react';
import { Zap, Hand, Gauge } from 'lucide-react';

const ModeSelector = ({ currentMode, onModeChange, disabled }) => {
  const modes = [
    { value: 'auto', label: 'Auto', icon: Zap, color: 'purple' },
    { value: 'semi_auto', label: 'Semi-Auto', icon: Gauge, color: 'blue' },
    { value: 'manual', label: 'Manuel', icon: Hand, color: 'orange' }
  ];

  return (
    <div className="flex items-center gap-2 bg-dark-card/80 border border-sunset-orange/30 rounded-xl p-2">
      <span className="text-xs text-sunset-orange font-semibold px-2">MODE:</span>
      <div className="flex gap-1">
        {modes.map((mode) => {
          const Icon = mode.icon;
          const isActive = currentMode === mode.value;
          
          return (
            <button
              key={mode.value}
              onClick={() => !disabled && onModeChange(mode.value)}
              disabled={disabled}
              className={`flex items-center gap-2 px-3 py-1.5 rounded-lg transition-all ${
                isActive
                  ? `bg-${mode.color}-500/20 border-2 border-${mode.color}-500 text-white`
                  : 'border border-sunset-orange/20 text-sunset-orange hover:bg-purple-500/10'
              } disabled:opacity-50 disabled:cursor-not-allowed`}
            >
              <Icon className="w-4 h-4" />
              <span className="text-xs font-semibold">{mode.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ModeSelector;
